import axios from 'axios';

// const baseUrl = process.env.REACT_APP_URL_SERVER;
const baseUrl = process.env.REACT_APP_URL_METIOR;
const apiCode = process.env.REACT_APP_AZURE_CODE;

const authentication = {

  /**
   * Inicia sesion de un usuario
   */
  signUp: async (data) => {
    const response = axios({
      url: `${baseUrl}/api/users?code=${apiCode}`,
      method: 'POST',
      data,
    })
      .then((res) => res.data)
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },

  logIn: async (data) => {
    const response = axios({
      url: `${baseUrl}/api/login?code=${apiCode}`,
      method: 'POST',
      data,
    })
      .then((res) => res.data)
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },

};

export default authentication;
